export const serializeErrors = (errors) => (errors ?? []).map((error) => error.reason).join(' ');
